import UpdatePictureForm from "./UpdatePicture";
export default UpdatePictureForm;
